// Injects a Solid template's stylesheets, deduped by href. The links are
// fetched cross-origin from the private CDN bucket, so they need the signed
// Cloud-CDN-Cookie sent along (crossorigin="use-credentials").
export const addStylesheets = (urls: string[]): void => {
  urls.forEach((url) => {
    const alreadyAdded = [
      ...document.head.querySelectorAll('link[rel="stylesheet"]'),
    ].some((link) => link.getAttribute('href') === url)

    if (alreadyAdded) return

    const link = document.createElement('link')

    link.rel = 'stylesheet'
    link.crossOrigin = 'use-credentials'
    link.href = url

    document.head.appendChild(link)
  })
}
